var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmaildropdownicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5628 9.50329C12.0921 9.783 11.5516 9.93151 11 9.93151C10.4484 9.93151 9.90786 9.783 9.43643 9.50172L0 3.90979V14.0644C0 15.3608 1.05286 16.4215 2.35714 16.4215H19.6429C20.9471 16.4215 22 15.3608 22 14.0644V3.90979L12.5628 9.50329Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.1586 8.28614C10.4132 8.43779 10.7031 8.51714 11.0001 8.51714C11.2971 8.51714 11.5879 8.437 11.8409 8.28693L21.9915 2.27071C21.9451 1.01514 20.9174 0 19.643 0H2.35729C1.08286 0 0.0551462 1.01514 0.00878906 2.27071L10.1586 8.28614Z",
    fill: "#8D90A5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmaildropdownicon);
export default __webpack_public_path__ + "static/media/emaildropdownicon.76f7b0025f8bd4eb92140e074e7c7c5e.svg";
export { ForwardRef as ReactComponent };